import React from 'react';
import { RegularMetricId } from '../../../../api/types-graphql';
import { ExternalChartComponentProps } from '../../../../common/components/data-viz-containers/common/types';
import { KpiFactboxTwoMetricViz } from '../../../../common/components/data-viz-containers/kpi-factbox-two-metric/TwoMetricKpiFactboxViz';
import {
  KpiFactboxTwoMetricVizConfig,
  KpiFactboxTwoMetricVizViews,
} from '../../../../common/components/data-viz-containers/kpi-factbox-two-metric/types';
import { Languages } from '../../../../constants';
import { SingleValueTimeSelection } from '../../../../types';

export const AppsAndPassthroughFactbox = (props: {
  timeSelection: SingleValueTimeSelection;
  externalProps: ExternalChartComponentProps;
  filters?: string;
}) => {
  const { timeSelection, externalProps, filters } = props;
  const twoMetricFactboxConfig: KpiFactboxTwoMetricVizConfig = {
    sections: {
      leftSection: {
        title: {
          [Languages.EN]: '応募からの内定承諾率',
          [Languages.JA]: '応募からの内定承諾率',
        },
        query: {
          metric: {
            type: 'RegularMetricId' as const,
            value: RegularMetricId.Pm0276_2ApplicationsAtHiredPerApps,
          },
          timeSelection,
          filters,
        },
      },
      rightSection: {
        title: {
          [Languages.EN]: '内定承諾率',
          [Languages.JA]: '内定承諾率',
        },
        query: {
          metric: {
            type: 'RegularMetricId' as const,
            value: RegularMetricId.Pm0273_1PassthroughAtOfferPerc,
          },
          timeSelection,
          filters,
        },
      },
    },
  };
  return (
    <KpiFactboxTwoMetricViz
      dataConfig={twoMetricFactboxConfig}
      selectedView={KpiFactboxTwoMetricVizViews.FACTBOX}
      externalProps={externalProps}
      persistenceKey={`new-grad-recruitment-apps-and-passthrough-factbox-${filters ?? ''}`}
    />
  );
};
